import ICategory from "@/apps/AwardsWidget/models/category";

export interface IConfig {
    title: string;
    categories: ICategory[];
}

export interface IAwardsWidgetState {
    navigationOpen: boolean;
    recipientsLimit: number;
    selectedCategory: ICategory;
    categories: ICategory[];
}

export class AwardsWidgetState implements IAwardsWidgetState {
    navigationOpen: boolean = false;
    recipientsLimit: number = 10;
    selectedCategory: ICategory = {
        name: "",
        description: "",
        recipients: [],
        categories: [],
        selected: true,
        numberOfAwards: 0
    };
    categories: ICategory[] = [];
}
